import { render, staticRenderFns } from "./App.vue?vue&type=template&id=cebbabc4&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=cebbabc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebbabc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Proyects\\Happybox\\happyboxstore-repo\\email-shipping\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cebbabc4')) {
      api.createRecord('cebbabc4', component.options)
    } else {
      api.reload('cebbabc4', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=cebbabc4&scoped=true&", function () {
      api.rerender('cebbabc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmailShipping/App.vue"
export default component.exports